import lng from '@lightningjs/core';
import { Colors } from '@lightningjs/sdk';

export default class VODInfo extends lng.Component {
  static _template() {
    return {
      ...super._template(),
      Info: {
        flex: { direction: 'column', justifyContent: 'center' },
        Title: {
          y: 70,
          text: {
            fontSize: 60,
            fontFace: 'OpenSans-SemiBold',
            lineHeight: 68,
            maxLines: 2,
            wordWrapWidth: 610,
            shadow: true,
            shadowColor: Colors('#000000').get(),
            shadowOffsetX: 0,
            shadowOffsetY: 3,
            shadowBlur: 6,
          },
        },
        Informations: {
          y: 55,
          DurationAndIcon: {
            Svg: {
              y: 3,
              w: 25,
              h: 25,
              zIndex: 0,
            },
            text: {
              fontFace: 'OpenSans-Regular',
              fontSize: 26,
              maxLines: 1,
              wordWrapWidth: 600,
              shadow: true,
              shadowColor: Colors('#000000').get(),
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              shadowBlur: 6,
            },
          },
          Rating: {
            text: {
              fontFace: 'OpenSans-SemiBold',
              fontSize: 25,
              maxLines: 1,
              wordWrapWidth: 600,
              shadow: true,
              shadowColor: Colors('#000000').get(),
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              shadowBlur: 6,
            },
          },
          Votes: {
            y: 7,
            text: {
              fontSize: 18,
              maxLines: 1,
              wordWrapWidth: 600,
              shadow: true,
              shadowColor: Colors('#000000').get(),
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              shadowBlur: 6,
            },
          },
          ContentRating: {
            x: 375,
            text: {
              fontFace: 'OpenSans-Regular',
              fontSize: 26,
              maxLines: 1,
              wordWrapWidth: 600,
              shadow: true,
              shadowColor: Colors('#000000').get(),
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              shadowBlur: 6,
            },
          },
        },
        Category: {
          y: 100,
          text: {
            fontFace: 'OpenSans-Regular',
            fontSize: 24,
            maxLines: 1,
            wordWrapWidth: 600,
            shadow: true,
            shadowColor: Colors('#000000').get(),
            shadowOffsetX: 0,
            shadowOffsetY: 3,
            shadowBlur: 6,
          },
        },
        Description: {
          y: 120,
          h: 200,
          text: {
            fontFace: 'OpenSans-SemiBold',
            fontSize: 30,
            lineHeight: 40,
            wordWrapWidth: 610,
            maxLines: 3,
            shadow: true,
            shadowColor: Colors('#000000').get(),
            shadowOffsetX: 0,
            shadowOffsetY: 3,
            shadowBlur: 6,
          },
        },
      },
      Cover: {
        x: 520,
        y: 0,
        w: 1200, // Initial width
        h: 690, // Initial height
        alpha: 0.9,
        texture: {
          type: lng.textures.ImageTexture,
        },
        shader: { type: lng.shaders.FadeOut, fade: [0, 0, 90, 90] },
      },
    };
  }
}
